import React, { useState, useEffect } from "react";
import Dropzone from "react-dropzone";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";

const DropFileContent = ({ file, type, index, onDrop }) => {
  let accept = "video/*";
  let text = "";
  switch (type) {
    case "video":
      accept = "video/*";
      text = `비디오 파일`;
      break;
    case "image":
      accept = "image/*";
      text = `이미지 파일`;
      break;
    case "audio":
      accept = "audio/*";
      text = `오디오 파일`;
      break;
    case "text":
      accept = ".txt,.csv,.json";
      text = `텍스트 파일`;
      break;
  }

  const [dropFile, setDropFile] = useState();
  const [fileUploading, setFileUploading] = useState(false);

  useEffect(() => {
    if (file) {
      setFileUploading(false);
      setDropFile(file);
    }
  }, [file]);

  return (
    <Dropzone
      accept={accept}
      onDrop={(e) => {
        onDrop(e, type, index);
        setFileUploading(true);
        setDropFile();
      }}
      multiple={false}
    >
      {({ getRootProps, getInputProps }) =>
        dropFile ? (
          <div className="w-full h-full rounded-md aiso_glass_in_bg">
            <div className="md:flex items-center font-bold py-3 px-4 inoutput_header">
              <div className="whitespace-pre text-base mr-2">{text}</div>
            </div>
            <div {...getRootProps()} className="w-full flex flex-col items-center justify-center md:h-52 lg:h-40">
              <div className="w-full h-full flex justify-start items-center px-6 py-4 cursor-pointer">
                <input {...getInputProps()} />
                <p className="text-lg text-black font-bold mb-0">{dropFile.name}</p>
              </div>
            </div>
          </div>
        ) : fileUploading ? (
          <div className="w-full h-full rounded-md aiso_glass_in_bg">
            <div className="md:flex items-center font-bold py-3 px-4 inoutput_header">
              <div className="whitespace-pre text-base mr-2">{text}</div>
            </div>
            <div className="w-full flex flex-col items-center justify-center p-2 py-4 md:h-52 lg:h-40">
              <div className="w-full h-full flex center border-dashed border-2 border-white rounded-md px-2 py-4 cursor-pointer">
                <div className="center">
                  <div className="circle-loader"></div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="w-full h-full rounded-md aiso_glass_in_bg">
            <div className="md:flex items-center font-bold py-3 px-4 inoutput_header">
              <div className="whitespace-pre text-base mr-2">{text}</div>
            </div>
            <div {...getRootProps()} className="w-full flex flex-col items-center justify-center p-2 py-4 md:h-52 lg:h-40">
              <div className="w-full h-full flex center border-dashed border-2 border-white rounded-md px-2 py-4 cursor-pointer">
                <input {...getInputProps()} />
                <p className="text-aaa text-lg text-aaa flex items-center mb-0">
                  <CloudUploadIcon />
                  <span className="ml-3">이미지 파일 업로드</span>
                </p>
              </div>
            </div>
          </div>
        )
      }
    </Dropzone>
  );
};

export default DropFileContent;
